import { Row } from 'antd';
import Styles from './index.module.scss';
import TrendImg from './TrendImg';

interface IProps {
  value: string | number;
  unit: string | number;
  desc: string | number;
  type?: 'down' | 'up';
}

const IndicatorCard = ({ value, unit, desc, type }: IProps) => {
  return (
    <div className={Styles.indicatorCard}>
      <div className={Styles.container}>
        <span className={Styles.value}>{value}</span>
        <div className={Styles.unitContainer}>
          {/* <TrendImg type={type} /> */}
          <span className={Styles.unit}>{unit}</span>
        </div>
      </div>
      <div className={Styles.desc}>{desc}</div>
    </div>
  );
};

export default IndicatorCard;
